import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ViewStatistic from './view-statistic-model'
import {
  CreateViewStatisticAsync,
  DeleteViewStatisticAsync,
  LoadViewStatisticsAsync,
} from './viewStatistic-thunk'
const initialState: viewStatisticSliceState = {
  viewStatistic: [],
  selected_viewStatistic: '',
  is_loading_viewStatistic: false,
  is_creating_viewStatistic: false,
  is_deleting_viewStatistic: false,
}
export interface viewStatisticSliceState {
  viewStatistic: ViewStatistic[]
  selected_viewStatistic?: string
  is_loading_viewStatistic: boolean
  is_creating_viewStatistic: boolean
  is_deleting_viewStatistic: boolean
}
export const viewStatisticSlice = createSlice({
  name: 'viewStatistic',
  initialState,
  reducers: {
    setSelectedviewStatistic: (state, action) => {
      state.selected_viewStatistic = action.payload
    },
    clearStateviewStatistic: (state) => {
      state.viewStatistic = []
      state.is_loading_viewStatistic = false
      state.is_creating_viewStatistic = false
      state.is_deleting_viewStatistic = false
    },
    mergeviewStatistic: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_viewStatistic = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.viewStatistic = merge(state.viewStatistic, payload) as any
        }
      }
    },

    add_viewStatistic: (state, action) => {
      if (action.payload) {
        state.viewStatistic = [...state.viewStatistic, action.payload]
      }
    },
    set_viewStatistic: (state, action) => {
      let { key, value, id } = action.payload
      state.viewStatistic = state.viewStatistic.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadViewStatisticsAsync.pending, (state) => {
      state.is_loading_viewStatistic = true
    })
    builder.addCase(LoadViewStatisticsAsync.fulfilled, (state, action) => {
      state.is_loading_viewStatistic = false
      if (action.payload) {
        state.viewStatistic = action.payload
      }
    })
    builder.addCase(LoadViewStatisticsAsync.rejected, (state) => {
      state.is_loading_viewStatistic = false
    })
    builder.addCase(CreateViewStatisticAsync.pending, (state) => {
      state.is_creating_viewStatistic = true
    })
    builder.addCase(CreateViewStatisticAsync.fulfilled, (state) => {
      state.is_creating_viewStatistic = false
    })
    builder.addCase(CreateViewStatisticAsync.rejected, (state) => {
      state.is_creating_viewStatistic = false
    })
    builder.addCase(DeleteViewStatisticAsync.pending, (state) => {
      state.is_deleting_viewStatistic = true
    })
    builder.addCase(DeleteViewStatisticAsync.fulfilled, (state, action) => {
      state.is_deleting_viewStatistic = false
      if (state.viewStatistic) {
        state.viewStatistic = state.viewStatistic.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteViewStatisticAsync.rejected, (state) => {
      state.is_deleting_viewStatistic = false
    })
  },
})

export const {
  clearStateviewStatistic,
  setSelectedviewStatistic,
  set_viewStatistic,
  mergeviewStatistic,
  add_viewStatistic,
} = viewStatisticSlice.actions

export const get_viewStatistic =
  (id?: string) =>
  (state: {
    viewStatistic: {
      viewStatistic: ViewStatistic[]
    }
  }): ViewStatistic | null => {
    let temp = state?.viewStatistic?.viewStatistic?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.viewStatistic?.viewStatistic[0] || null
  }
export const get_selected_viewStatistic = (state: {
  viewStatistic: viewStatisticSliceState
}): ViewStatistic | null => {
  let id = state?.viewStatistic?.selected_viewStatistic
  let temp = state?.viewStatistic?.viewStatistic?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_viewStatistic = (state: {
  viewStatistic: {
    viewStatistic: ViewStatistic[]
  }
}): ViewStatistic[] => {
  let temp = state?.viewStatistic?.viewStatistic
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_viewStatistic_busy = (state: {
  viewStatistic: viewStatisticSliceState
}) => {
  return (
    state?.viewStatistic.is_deleting_viewStatistic ||
    state?.viewStatistic.is_loading_viewStatistic ||
    state?.viewStatistic.is_creating_viewStatistic
  )
}
export const is_deleting_viewStatistic_busy = (state: {
  viewStatistic: viewStatisticSliceState
}) => {
  return state?.viewStatistic.is_deleting_viewStatistic
}
export const is_loading_viewStatistic_busy = (state: {
  viewStatistic: viewStatisticSliceState
}) => {
  return state?.viewStatistic.is_loading_viewStatistic
}
export const is_creating_viewStatistic_busy = (state: {
  viewStatistic: viewStatisticSliceState
}) => {
  return state?.viewStatistic.is_creating_viewStatistic
}

export default viewStatisticSlice.reducer
